import React from 'react';
export function AboutPage() {
  return <div className="w-full bg-white" data-id="element-59">
      <div className="container mx-auto px-4 py-16" data-id="element-60">
        <div className="max-w-3xl mx-auto" data-id="element-61">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-62">
            About Me
          </h1>
          <div className="mb-12 max-w-md mx-auto" data-id="element-63">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8vYnR9BQ9MsBmxwsWop4YK/Generated_Image_September_17%2C_2025_-_8_12PM~2.png" alt="Azn Shawn Alahah in a professional navy suit" className="w-full h-auto rounded-lg shadow-md" data-id="element-64" />
          </div>
          <div className="prose max-w-none" data-id="element-65">
            <p className="text-lg mb-6" data-id="element-66">
              I'm a polymath and entrepreneur with a deep interest in
              technologies that expand and augment human intelligence. I run an
              equity-capital and operational-assistance firm that partners with
              early-stage technology ventures. I'm drawn to high-risk,
              high-reward opportunities—comfortable in ambiguity, energized by
              complexity, and motivated by the constant evolution of our space.
            </p>
            <p className="mb-6" data-id="element-67">
              To me, entrepreneurship isn't merely about business creation; it's
              a form of self-overcoming—an act of will, creativity, and
              continuous transformation.
            </p>
            <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4" data-id="element-68">
              Background
            </h2>
            <p className="mb-6" data-id="element-69">
              From an early age, I was driven by a desire to understand and
              create. I entered college at sixteen, full of energy and
              curiosity, but quickly realized that the conventional education
              system prized obedience over originality. The so-called "elites"
              excelled at filling out worksheets, not thinking for themselves.
              That realization set me on a different trajectory.
            </p>
            <p className="mb-6" data-id="element-70">
              I left to pursue my own path—a kind of vision quest—to explore,
              build, and define my own values. Over the years, I've been
              involved in founding and scaling multiple startups, gaining
              firsthand experience in nearly every dimension of organizational
              growth: sales strategy, business development, team leadership,
              product/engineering coordination, marketing, PR, and public
              representation. I've hired, trained, and managed teams across
              disciplines and learned that the greatest discoveries come not
              from success but from self-reflection.
            </p>
            <p className="mb-6" data-id="element-71">
              When I eventually returned to academia, I studied philosophy and
              computer science—two lenses through which I could examine both
              consciousness and computation. I concluded that intelligence
              itself is the ultimate creative force, and that the future will be
              shaped by those who can synthesize thought, code, and vision into
              new forms of life.
            </p>
            <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4" data-id="element-72">
              Philosophy
            </h2>
            <p className="mb-6" data-id="element-73">
              I subscribe to a Nietzschean worldview: that life itself is an
              expression of energy striving to expand, to overcome, and to
              create. Living things aim to discharge their strength—to express
              their "will to power"—even if that involves danger, pain, or
              contradiction.
            </p>
            <p className="mb-6" data-id="element-74">
              What counts as good or desirable depends entirely on the type of
              person one is: whether one is strong, ascending, and
              life-affirming—or weak, declining, and constrained. Life doesn't
              will what it already possesses; it wills excess, increase, and
              abundance.
            </p>
            <p className="mb-6" data-id="element-75">
              To create yourself—to define your own values and direction—is the
              highest responsibility. Through struggle, solitude, and
              discipline, you forge strength and meaning. I see business,
              science, and art all as extensions of that same impulse: the drive
              to transform reality through creative power.
            </p>
            <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4" data-id="element-76">
              Current Focus
            </h2>
            <p className="mb-6" data-id="element-77">
              My present work centers on building ventures that accelerate the
              evolution of intelligence—artificial, augmented, and collective.
              I'm particularly interested in the convergence of AI,
              biotechnology, and human cognition.
            </p>
            <p className="mb-6" data-id="element-78">
              As John Ciardi wrote, "Intelligence recognizes what has happened.
              Genius recognizes what will happen." I'm working toward the
              latter: anticipating and engineering the systems that will define
              civilization's next leap.
            </p>
            <p className="mb-6" data-id="element-79">
              Artificial General Intelligence represents, in my view, the
              greatest revolution in history. As I.J. Good theorized, once a
              machine can design better machines, an "intelligence explosion"
              will follow—transforming every domain of life. My goal is to help
              steer that transformation toward creation rather than chaos,
              abundance rather than stagnation.
            </p>
            <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4" data-id="element-80">
              Beyond Work
            </h2>
            <p className="mb-6" data-id="element-81">
              Outside the lab and boardroom, I live life intensely but lightly.
              I've traveled to over 30 countries and lived in six, finding
              inspiration in every culture I've encountered. I enjoy cycling,
              MMA, CrossFit, basketball, and camping. I also spend a lot of time
              in cafes or by the sea—thinking, writing, and occasionally being
              absurd.
            </p>
            <p className="mb-6" data-id="element-82">
              I can be direct, commanding, and unapologetically hands-on, but
              I'm also genial and grounded. (Fun fact: I'm a qualified
              head-to-toe massage therapist.) I'm happiest when I'm creating,
              learning, or exploring the unknown—and I've learned that
              seriousness and play are not opposites, but complements.
            </p>
            <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-83">
              <p className="italic" data-id="element-84">
                "Inside every real man is a child who wants to play." —
                Friedrich Nietzsche
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}